import React from 'react';
import styled from '@emotion/styled';
import { IPrismicPageBase } from '@appTypes';
import { theme } from '@styles';
import Button from '@components/Button';
import { Link } from 'gatsby';
import { MOUNTAIN_MEADOW } from '@constants';
import { useWindowWidth } from '@customHooks';
import VideoCta from './VideoCta';

const { colors, breakpoints } = theme;

type Props = {
  customTitle?: string;
  customSubtitle?: string;
  subscribeForm?: boolean;
};

const CallToActionSection: React.FC<Props & IPrismicPageBase> = ({ prismicCtaData }) => {
  const data = prismicCtaData!.edges[0].node.data;
  const { cta_section_title, cta_buttons } = data;
  const windowWidth = useWindowWidth();

  const breakpointSmallLaptop = 769;
  const breakpointIsMobile = windowWidth < breakpointSmallLaptop;

  return (
    <Wrapper id='cta-footer'>
      <Content>
        <Title
          dangerouslySetInnerHTML={{
            __html: cta_section_title.html,
          }}
        />
        <HeaderButtons>
          {cta_buttons.map(({ button_is_external, button_id, button_label, button_link, button_primary }, index) => (
            <Link id={button_id} key={index} to={button_link} target={button_is_external ? '_blank' : '_self'}>
              <Button
                theme='dark'
                id={button_id}
                type={button_primary ? 'primary' : 'secondary'}
                label={button_label}
                width={breakpointIsMobile ? '100%' : 157}
                height={53}
              />
            </Link>
          ))}
        </HeaderButtons>
      </Content>
      <VideoCta />
    </Wrapper>
  );
};

export default CallToActionSection;

const Content = styled.div`
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 170px 0px 30px 0px;
  @media screen and (min-width: ${breakpoints.desktop}) {
    margin: 0px;
  }
`;

const HeaderButtons = styled.div`
  a {
    text-decoration: none;
  }
  display: flex;
  gap: 17px;
  justify-content: flex-start;
  width: 100%;
  padding: 0 24px;
  svg {
    height: 40px;
    width: 100%;
  }
  flex-direction: column;
  @media screen and (min-width: ${breakpoints.desktop}) {
    flex-direction: row;
    justify-content: center;
    svg {
      height: 50px;
      width: 100%;
    }
  }
`;

const Title = styled.div`
  font-size: 25px;
  line-height: 36px;
  color: #fff;
  font-family: 'Poppins';
  font-weight: 700;
  letter-spacing: -0.2px;
  text-align: center;
  p {
    margin: 0px 24px 24px 24px;
  }
  em {
    user-select: none;
    font-style: normal;
    color: ${MOUNTAIN_MEADOW};
  }
  @media screen and (min-width: ${breakpoints.desktop}) {
    font-size: 50px;
    line-height: 62px;
    letter-spacing: -0.2px;
    width: 800px;
    p {
      margin-bottom: 32px;
    }
  }
`;

const Wrapper = styled.div`
  background-color: ${colors.mountainMeadow};
  margin: 120px 22px 50px 22px;
  position: relative;
  z-index: 1;
  border-radius: 30px;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  @media screen and (min-width: ${breakpoints.desktop}) {
    margin: 120px 22px 50px 22px;
    border-radius: 60px;
    max-width: 1200px;
    height: 441px;
    flex-direction: row;
    margin: 300px auto 100px auto;
  }
`;
